<script>
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Update Teacher',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      teacherError: null,
      isteacherError: false,
      isLoading: false,
      show: false,
      platformId: '',
      teacherId: null,
      teacherSuccess: '',
      isSuccess: false,
      departmentlist: [],
      departmentId: '',
      phone: '',
      teacherRole: '',
      collegeId: '',
      collegeClass: [],
      classlist: [],
      classEmptyError: false,
      zoomUserId: null,
      zoomUserIdEmpty: false,
      zoomUserList: [],
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
  },
  mounted() {
    this.getDepartments()
    this.collegeId = this.profileData.college_id
    if (this.role === 'teacher') {
      this.collegeClass = this.profileData.collegeClass
    }
    this.platformId = this.profileData.platform_id
    this.getZoomUser()
  },
  methods: {
    ...userListMethod,
    ...departmentListMethod,
    getZoomUser() {
      this.getZoomUsers().then((res) => {
        var listitems = []
        listitems.push({ text: 'Select User', value: 'null', disabled: true })
        res.users.forEach((element) => {
          if (
            this.platformId === 2 &&
            element.id === '-mOOLRHeQ7G765dWTmMymA'
          ) {
          } else {
            let ele = {}
            ele.text =
              element.first_name +
              ' ' +
              element.last_name +
              ' (' +
              element.id +
              ')'
            ele.value = element.id
            listitems.push(ele)
          }
        })
        this.zoomUserList = listitems
      })
    },
    getDepartments() {
      this.departmentId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
    getClasses() {
      this.collegeClass = []
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            if (this.departmentId === element.department) {
              ele.text = element.name
              ele.value = element._id
              ele.college = element.college_id
              listitems.push(ele)
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },
    // save teacher method
    saveTeacherDetails() {
      if (this.collegeClass.includes('All')) {
        this.classlist.shift('All')
        this.collegeClass = []
        for (let i = 0; i < this.classlist.length; i++) {
          this.collegeClass[i] = this.classlist[i].value
        }
      }
      if (
        (this.collegeClass.length === 0 || this.departmentId.length === 0) &&
        this.teacherRole === 'teacher'
      ) {
        this.classEmptyError = true
        this.isLoading = false
      } else {
        this.classEmptyError = false
      }
      if (this.zoomUserId === null) {
        this.zoomUserIdEmpty = true
      } else {
        this.zoomUserIdEmpty = false
      }
      if (!this.classEmptyError && !this.zoomUserIdEmpty) {
        let Data = {
          id: this.data._id,
          first_name: this.firstName,
          last_name: this.lastName,
          department: this.departmentId,
          zoom_userId: this.zoomUserId,
        }
        if (this.teacherRole === 'teacher') {
          Data.collegeClass = this.collegeClass
        }
        if (this.phone.toString() !== this.data.phone.toString()) {
          Data.phone = this.phone
        }
        this.updateUser({ Data })
          .then((teacher) => {
            this.isLoading = false
            this.isteacherError = false
            this.teacherSuccess = 'Details Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.teacherError = getError.message
            this.isteacherError = true
          })
      }
    },

    resetModal() {
      this.firstName = this.data.first_name
      this.lastName = this.data.last_name
      this.phone = this.data.phone
      this.department = this.data.department
      this.teacherError = ''
      this.isteacherError = false
      this.classEmptyError = false
      this.teacherSuccess = ''
      this.isSuccess = false
      this.teacherRole = this.data.role
      this.departmentId = ''
      this.collegeClass = []
      this.zoomUserId = null
    },
    getData() {
      this.firstName = this.data.first_name
      this.lastName = this.data.last_name
      this.departmentId = this.data.department
      this.phone = this.data.phone
      this.teacherRole = this.data.role
      if (this.data.zoom_userId !== undefined) {
        this.zoomUserId = this.data.zoom_userId
      }
      if (this.teacherRole === 'teacher') {
        this.getClasses()
        this.collegeClass = this.data.collegeClass
      }
    },
  },
}
</script>

<template>
  <b-modal
    id="teacher-modal"
    title="Update "
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="teacherSuccess"
        ></b-alert>
        <b-form @submit.prevent="saveTeacherDetails">
          <b-form-group label="First Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="firstName"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Last Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="lastName"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Email" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="data.email"
              type="text"
              disabled
              style="cursor:not-allowed;background:#e0d9d9;"
            ></b-form-input>
          </b-form-group>

          <!--<b-form-group label="Role(Upgrade teacher)" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="teacherRole"
              type="text"
            ></b-form-input>
          </b-form-group> -->

          <b-form-group label="Phone" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="phone"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            v-if="role !== 'hod' && role !== 'teacher'"
            label="Department"
            label-for="input-1"
          >
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
              @change="getClasses"
            ></b-form-select>
          </b-form-group>

          <b-form-group
            v-if="teacherRole === 'teacher'"
            label="Class"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeClass"
              :options="classlist"
              multiple
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Select Zoom User Id*" label-for="input-1">
            <b-form-select
              v-model="zoomUserId"
              :options="zoomUserList"
            ></b-form-select>
          </b-form-group>
          <p v-if="zoomUserIdEmpty" style="color:red;"
            >Please add Zoom user Id</p
          >
          <p v-if="classEmptyError" style="color:red;"
            >Please select class/department</p
          >
          <b-alert
            v-model="isteacherError"
            variant="danger"
            v-html="teacherError"
          ></b-alert>

          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
